export const getters = {
  getUserData(state) {
    return state.datauser;
  },
  getUsuario(state) {
    return state.usuario;
  },
  itemsMenuWithSubMenu(state) {
    const tipeUser = state.datauser.tipo_usuario
      ? state.datauser.tipo_usuario
      : "public";
    return state.itemsMenuFull
      .filter((item) => {
        return (
          item.items.length > 0 &&
          item.role.includes(tipeUser) &&
          item.items.filter((subitem) => {
            return subitem.role.includes(tipeUser);
          }).length > 0
        );
      })
      .map((item) => {
        return {
          id: item.id,
          label: item.label,
          items: item.items.filter((subitem) => {
            return subitem.role.includes(tipeUser);
          }),
        };
      });
  },
  itemsMenu(state) {
    const tipeUser = state.datauser.tipo_usuario
      ? state.datauser.tipo_usuario
      : "public";
    if (state.datauser.cambiar_password == 1) {
      return [];
    }
    return state.itemsMenuFull.filter((item) => {
      return item.role.includes(tipeUser);
    }).map((item) => {
      item.items=item.items.filter((subitem) => {
        return subitem.role.includes(tipeUser);
      })
      return item;
    });
  }  
};
